export default "__VITE_ASSET__CXvIjJ2i__"